import { InvocationState } from './InvocationState';

export const offlineInvocationStates: InvocationState[] = [
  'OFFLINE',
  'OFFLINE_SETTLED'
];
